/**
 * @file: When a screen counts as quiet.
 *
 * A player sends a heartbeat every fifteen seconds, and the server writes the
 * time on the scene. Three missed heartbeats mean the screen is quiet. The
 * scene page shows that as a red dot, and the play report lists it as a
 * finding. Both read the two numbers here, so one screen never gets two
 * answers.
 */

/** The player sends a heartbeat this often. */
const HEARTBEAT_MS = 15000

/** Three missed heartbeats. A shorter limit blinks on every slow network. */
const QUIET_AFTER_MS = 3 * HEARTBEAT_MS

/**
 * True when the last heartbeat is older than the limit. `lastSeenSeconds` is
 * the epoch value the scene holds. A scene that was never seen is not quiet:
 * it has no player yet, and the caller decides what to show for it.
 */
function isQuiet (lastSeenSeconds, nowMs) {
  if (!lastSeenSeconds) {
    return false
  }
  return nowMs - lastSeenSeconds * 1000 >= QUIET_AFTER_MS
}

export {
  HEARTBEAT_MS,
  QUIET_AFTER_MS,
  isQuiet
}
